import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import AboutRavenne from "@/pages/AboutRavenne";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/about-ravenne" element={<AboutRavenne />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
